import { FC } from 'react'
import styles from './shared-hosting-offer-card.module.scss'
import OfferCard from '../OfferCard'
import { useTranslation } from 'react-i18next'

type SharedHostingOfferCardProps = {}

const SharedHostingOfferCard: FC<SharedHostingOfferCardProps> = ({}) => {
  const { t } = useTranslation()

  return (
    <OfferCard
      title={t('hosting-for-site')}
      button={{ text: t('more-details'), href: '/hosting' }}
      bgClassName={styles.bg}
      bgSrc={'/img/bg/virtual-hosting.svg'}
    >
      {t('hosting-slogan')}
    </OfferCard>
  )
}

export default SharedHostingOfferCard
